import React from 'react';
import Card from './card';

const Welcome = (props) => (
  <Card
    title="To help you understand what kind of home you can afford we need to ask some questions. This should take less than 3 minutes."
    {...props}
  />
);
Welcome.id = 'AffordabilityWelcome';
Welcome.completed = ({ model }) => model.getIn(['loan', 'termsAgree']);
export default Welcome;



// WEBPACK FOOTER //
// ./src/cards/welcome/affordability.js